import PagarPagamentoService from "@/services/PagarPagamentoService";

export const pagarPagamento = {
  namespaced: true,
  state: {
    pagarPagamento: {},
  },
  actions: {
    getPagarPagamento({ commit }, payload) {
      return PagarPagamentoService.GetPagarPagamento(payload).then(
        (pagarPagamento) => {
          return Promise.resolve(pagarPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPagarPagamento({ commit }, payload) {
      return PagarPagamentoService.PostPagarPagamento(payload).then(
        (pagarPagamento) => {
          return Promise.resolve(pagarPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPagarPagamento({ commit }, payload) {
      return PagarPagamentoService.PutPagarPagamento(payload).then(
        (pagarPagamento) => {
          return Promise.resolve(pagarPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePagarPagamento({ commit }, payload) {
      return PagarPagamentoService.DeletePagarPagamento(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPagarPagamentoOData({ commit }, payload) {
      return PagarPagamentoService.GetPagarPagamentoOData(payload).then(
        (pagarPagamento) => {
          return Promise.resolve(pagarPagamento);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pagarPagamento;
